import { Component, Inject } from '@angular/core';
import { PopUpComponent } from '../pop-up.component';
import { Direction } from '@angular/cdk/bidi';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { Overlay } from '@angular/cdk/overlay';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import {
  BOARDING_AND_DROP_OFF_STATIONS_NOT_IN_ROUTE_FOR_DATE,
  BOARDING_STATION_NOT_IN_ROUTE_FOR_DATE,
  CLOSE,
  DROP_OFF_STATION_NOT_IN_ROUTE_FOR_DATE,
  STATION_CODE,
} from 'src/app/modules/route-planner/constants/multi-language.constants';
import { POPUP_DATA } from 'src/app/@shared/services/modal/modal.service';
import { Stop } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/stop.interface';

@Component({
    selector: 'app-stops-changed-pop-up',
    templateUrl: './stops-changed-pop-up.component.html',
    styleUrl: './stops-changed-pop-up.component.scss',
    standalone: false
})
export class StopsChangedPopUpComponent extends PopUpComponent {

  direction: Direction
  closeText: string
  stopsChangedText: string
  stationCodeText: string
  removedBoardingStopName: string
  removedDropingStopName: string

  constructor(
    routePlanningService: RoutePlanningService,
    resizeService: ResizeService,
    overlay: Overlay,
    @Inject(POPUP_DATA)
    public readonly data: { removedBoardingStop: Stop | null; removedDropingStop: Stop | null },
    private readonly languageService: LanguageService,
  ) {
    super(routePlanningService, resizeService, overlay);
  }

  override ngOnInit(): void {
    super.ngOnInit()
    this.initializeMultiLanguageTexts()
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.direction = language.direction
      this.closeText = CLOSE[language.language]
      this.stationCodeText = STATION_CODE[language.language]

      if (this.data.removedBoardingStop && this.data.removedDropingStop) {
        this.stopsChangedText = BOARDING_AND_DROP_OFF_STATIONS_NOT_IN_ROUTE_FOR_DATE[language.language]
      } else if (this.data.removedBoardingStop) {
        this.stopsChangedText = BOARDING_STATION_NOT_IN_ROUTE_FOR_DATE[language.language]
      } else {
        this.stopsChangedText = DROP_OFF_STATION_NOT_IN_ROUTE_FOR_DATE[language.language]
      }

      this.removedBoardingStopName = this.getStopName(this.data.removedBoardingStop, language.symbol)
      this.removedDropingStopName = this.getStopName(this.data.removedDropingStop, language.symbol)
    })
  }

  private getStopName(stop: Stop | null, languageSymbol: string): string {
    return stop?.name?.[languageSymbol] || stop?.name?.he || '';
  }
}
